import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LeadsService } from '../../../../modules/leads/services/leads.service';

@Component({
  selector: 'app-leads-scan-tasks-kanban-filter',
  templateUrl: './leads-scan-tasks-kanban-filter.component.html',
  styleUrls: ['./leads-scan-tasks-kanban-filter.component.scss']
})
export class LeadsScanTasksKanbanFilterComponent implements OnInit {
  @Output() onFilter$ = new EventEmitter<void>();
  constructor(
    public leadsService: LeadsService,
    ) { }

  ngOnInit(): void {
  }

  setFilterWork($event: any) {
    this.onFilter$.next();
  }
}
